import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d0b65b3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "grid-layout" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c0" }, null, -1))
const _hoisted_6 = { class: "caja c1" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Teléfono: "),
  /*#__PURE__*/_createElementVNode("span", null, "(829) 995-1122 ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "E-Mail: "),
  /*#__PURE__*/_createElementVNode("span", null, "admfinancierarodriguez@gmail.com ")
], -1))
const _hoisted_10 = { class: "caja c2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold" }, " Nota de Débito ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "No: ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NCF: ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c7" }, null, -1))
const _hoisted_16 = { class: "caja c3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cliente: ", -1))
const _hoisted_18 = { class: "caja c4" }
const _hoisted_19 = { class: "table table-hover" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "NCF Afectado"),
  /*#__PURE__*/_createElementVNode("th", null, "Valor")
], -1))
const _hoisted_21 = { class: "t izq" }
const _hoisted_22 = { class: "t der" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "firma" }, [
    /*#__PURE__*/_createElementVNode("p", null, "____________________________"),
    /*#__PURE__*/_createElementVNode("p", null, "Entregado Por")
  ])
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caja c6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "firma" }, [
    /*#__PURE__*/_createElementVNode("p", null, "____________________________"),
    /*#__PURE__*/_createElementVNode("p", null, "Recibido Por")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("body", null, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", _hoisted_7, _toDisplayString(this.documento.medico), 1),
          _createElementVNode("h5", null, _toDisplayString(this.documento.direccion), 1),
          _hoisted_8,
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("h5", null, [
            _hoisted_12,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatSecuence(_ctx.documento.no)), 1)
          ]),
          _createElementVNode("h5", null, [
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(_ctx.documento.literal + _ctx.formatNumber2(_ctx.documento.ncf)), 1)
          ]),
          _createElementVNode("h5", null, [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(this.documento.fechaNCF)), 1)
          ])
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h5", null, [
            _hoisted_17,
            _createElementVNode("span", null, _toDisplayString(this.documento.descCliente), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.documento.literalAfecta + _ctx.formatNumber2(_ctx.documento.ncfAfecta)), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatNumber(this.documento.debito)), 1)
            ])
          ])
        ]),
        _hoisted_23,
        _hoisted_24
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ], 64))
}